import React from 'react'
import PropTypes from 'prop-types'
import './AvailabilityAddButton.css'

function AvailabilityAddButton({
  onClick,
  className = '',
  label = 'Add Availability',
  title = 'Add availability',
  ariaLabel = 'Add new availability',
  testId,
}) {
  const buttonClassName = ['fl__availability-add-button', className]
    .filter(Boolean)
    .join(' ')

  return (
    <button
      type="button"
      className={buttonClassName}
      onClick={onClick}
      title={title}
      aria-label={ariaLabel}
      data-testid={testId}
    >
      <span className="fl__availability-add-button__icon" aria-hidden="true">
        +
      </span>
      <span className="fl__availability-add-button__text">{label}</span>
    </button>
  )
}

AvailabilityAddButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  className: PropTypes.string,
  label: PropTypes.string,
  title: PropTypes.string,
  ariaLabel: PropTypes.string,
  testId: PropTypes.string,
}

export default AvailabilityAddButton
